module.exports = __webpack_public_path__ + "static/remove_access_form_2-44810ee99b38bad4226ed0ea43774b38.png";